<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Товчоодын нэвтрэлт" />
    <div class="content-body pd-0-f">
      <div class="container pd-0-f">
        <terminals bd="bd-0" mgt=""></terminals>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
export default {
  components: {
    
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    terminals: () => ({
      component: import("@/views/apps/penalty/components/terminals.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  }
};
</script>
